import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { useGetTipoComprobante } from '@/shared/actions/erp';
import { useCheckPermissions, useLoaders } from '@/shared/hooks';
import { SaveTipoComprobante } from '../../shared/components';
import { ROUTER_PATHS } from '@/shared';

export type UpdateTipoComprobantePageProps = {};

const UpdateTipoComprobantePage: React.FC<
  UpdateTipoComprobantePageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_tipocomprobante);
  const returnUrlTiposComprobantePage =
  ROUTER_PATHS.administration.tipoComprobanteNav;
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetTipoComprobante(id!);
  useLoaders(isLoading);

  if (isLoading || isRefetching) return null;
  if (!data?.data?.id_tipocomprobante)
    return <Navigate to={returnUrlTiposComprobantePage} />;

  return (
    <SaveTipoComprobante
      title="Editar Tipo de Comprobante"
      tipocomprobante={data.data}
    />
  );
};

export default UpdateTipoComprobantePage;
